/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Passkey_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This browser cannot use passkeys" |
*
* @param {Signin_Passkey_UnsupportedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_passkey_unsupported = /** @type {((inputs?: Signin_Passkey_UnsupportedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Passkey_UnsupportedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This browser cannot use passkeys")
});